import { render, staticRenderFns } from "./UtmContentCreation.vue?vue&type=template&id=717a4fa3&scoped=true&"
import script from "./UtmContentCreation.vue?vue&type=script&lang=js&"
export * from "./UtmContentCreation.vue?vue&type=script&lang=js&"
import style0 from "./UtmContentCreation.vue?vue&type=style&index=0&id=717a4fa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a4fa3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VRow,VSwitch,VTextField})
